enum BounsInvoicePermission {
  Prem_BounsInvoice_View = 'Prem_BounsInvoice_View',
  Prem_BounsInvoice_Create = 'Prem_BounsInvoice_Create',
  Prem_BounsInvoice_Manage = 'Prem_BounsInvoice_Manage',
}

export default BounsInvoicePermission;
